import {authAxios} from './../../config/axios';

class Menu{
	get=()=>{
		return authAxios.get('/administration/modules');
	}	
}

export default (new Menu());
